import { frontendURL } from '../../../helper/URLHelper';

import GenelBakis from './GoogleAdsGenelBakis.vue';
import Kampanyalar from './GoogleAdsKampanyalar.vue';
import Reklamlar from './GoogleAdsReklamlar.vue';
import AnahtarKelimeler from './GoogleAdsAnahtarKelimeler.vue';
import Kitleler from './GoogleAdsKitleler.vue';
import Donusumler from './GoogleAdsDonusumler.vue';
import Raporlar from './GoogleAdsRaporlar.vue';
import Otomasyonlar from './GoogleAdsOtomasyonlar.vue';
import Ayarlar from './GoogleAdsAyarlar.vue';

// Reklam yonetimi yalnizca yoneticiye acik: kampanya durdurmak/baslatmak
// para harcamasini etkiler, temsilci yetkisinde olmamali.
const YETKI = { permissions: ['administrator'] };

// Meta Ads'ten farkli olarak burada ust sekme YOK: dokuz bolumun hepsi
// kenar cubugunda tek tek duruyor. Google Ads'te bolumler birbirinden
// bagimsiz; araya bir sekme katmani koymak fazladan bir tiklama olurdu.
const sayfa = (yol, ad, bilesen) => ({
  path: frontendURL(`accounts/:accountId/google-ads${yol}`),
  name: ad,
  component: bilesen,
  meta: YETKI,
});

export const routes = [
  sayfa('', 'google_ads_genel_bakis', GenelBakis),
  sayfa('/kampanyalar', 'google_ads_kampanyalar', Kampanyalar),
  sayfa('/reklamlar', 'google_ads_reklamlar', Reklamlar),
  sayfa('/anahtar-kelimeler', 'google_ads_anahtar_kelimeler', AnahtarKelimeler),
  sayfa('/kitleler', 'google_ads_kitleler', Kitleler),
  sayfa('/donusumler', 'google_ads_donusumler', Donusumler),
  sayfa('/raporlar', 'google_ads_raporlar', Raporlar),
  sayfa('/otomasyonlar', 'google_ads_otomasyonlar', Otomasyonlar),
  sayfa('/ayarlar', 'google_ads_ayarlar', Ayarlar),
];
